import { buildFieldSurfaceStyleFromKiot, type FieldSurfaceDefaults } from './types'

/**
 * Base ô lọc sidebar trái (rail filter).
 * Tạm giống form — chỉnh file này khi cần style riêng.
 */
export const FILTER_SIDEBAR_FIELD_SURFACE_STYLE = buildFieldSurfaceStyleFromKiot()

export const FILTER_SIDEBAR_FIELD_SURFACE_DEFAULTS: FieldSurfaceDefaults = {
  labelLayout: 'outline',
  labelShrink: true,
  size: 'small',
  variant: 'outlined',
  fullWidth: true,
}
